import { render, staticRenderFns } from "./orderSet.vue?vue&type=template&id=87aff5d2&scoped=true"
import script from "./orderSet.vue?vue&type=script&lang=js"
export * from "./orderSet.vue?vue&type=script&lang=js"
import style0 from "./orderSet.vue?vue&type=style&index=0&id=87aff5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aff5d2",
  null
  
)

export default component.exports